export const i18nChat = {
  title: 'Assistant',
  bot: 'Bot',
  user: 'User',
  send: 'Send',
  typing: 'Typing...',
  close: 'Close',
  placeholder: 'Ask anything',
  beta: 'Beta',
  help_title: 'How can I help you?',
  chat_suggestions: {
    cases: 'What are my open cases?',
    new_case: 'How to create a case?',
    asset: 'More details about a specific asset',
  },
  thinking: 'Thinking, wait a moment',
  messages: {
    error: 'Sorry, an error occurred. Please try again.',
    timeout:
      "I'm currently having trouble completing this request due to technical limitations caused by the volume or complexity of the data. You might get better results if you can rephrase your question in a more specific or focused way. I'm here to help!",
  },
  chat_history: {
    title: 'Chat history',
    today: 'Today',
    older: 'Older',
    start_new_chat: 'Start new chat',
    session: 'Session',
    delete_title: 'Are you sure you want to delete this chat?',
    delete_info:
      'This action has information that will be lost. Are you sure you want to continue?',
    delete_cancel: 'Cancel',
    delete_confirm: 'Yes, delete',
  },
};
